
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import ControlExpand from './control-expand'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "controlexpand"
    }}>{`ControlExpand`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Controls`}</p>
    <hr />
    <h2 {...{
      "id": "expand"
    }}>{`Expand`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For triggering a change in the interface in order to show content.`}</p>
    <Playground __position={1} __code={'<ControlExpand />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlExpand
    }} mdxType="Playground">
  <ControlExpand mdxType="ControlExpand" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={2} __code={'<ControlExpand disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlExpand
    }} mdxType="Playground">
  <ControlExpand disabled mdxType="ControlExpand" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "expand-disc"
    }}>{`Expand (disc)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For triggering a change in the interface in order to show content.
Useful in places where the control must overlap other objects.`}</p>
    <Playground __position={4} __code={'<ControlExpand disc />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlExpand
    }} mdxType="Playground">
  <ControlExpand disc mdxType="ControlExpand" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={5} __code={'<ControlExpand disc disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      ControlExpand
    }} mdxType="Playground">
  <ControlExpand disc disabled mdxType="ControlExpand" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={ControlExpand} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;